import { render } from "./SelectTema.vue?vue&type=template&id=c290d56e"
import script from "./SelectTema.vue?vue&type=script&lang=js"
export * from "./SelectTema.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__